import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class GroupClassAutologinProviderService {
    getGroupClassDetailsUrl(groupClassId: string): string {
        // Deep-link only. We deliberately do NOT pass a token in the URL:
        // CourtBooking runs on MSAL and has no fresh legacy token to hand off,
        // so the old ?autologin&token= carried a stale token (401 on employee-management,
        // 400 on azureToken/refresh) and leaked the refresh_token via URL/history/Referer.
        // GroupEx authenticates itself via MSAL silent SSO from the shared Entra session.
        return environment.groupClassesAppUrl + '/management/classes/' + groupClassId;
    }
}
